<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{$t('bulkMadAllRequestSupport')|capitalize}}</span>
            </v-card-title>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-select
                            :items="ls_types"
                            v-model="ls_type"
                        ></v-select>
                    </v-flex>

                  <div>
                    <vc-date-picker :locale="$i18n.locale" v-model="from_time" mode="dateTime" :max-date="max_date" :marks="masks" is24hr is-required>
                      <template v-slot="{ inputValue, inputEvents }">
                        <span class="mr-2">{{ $t('requestTime') | capitalize }}</span>
                        <span class="mr-2">{{ $t('from') | capitalize }}:</span>
                        <input
                          style="border-style: double !important;"
                          class="bg-white border px-2 py-1 rounded time-input mr-2"
                          :value="inputValue"
                          v-on="inputEvents"
                        />
                      </template>
                    </vc-date-picker>
                    <vc-date-picker :locale="$i18n.locale" v-model="to_time" mode="dateTime" :max-date="max_date" :min-date="from_time" :marks="masks" is24hr is-required>
                      <template v-slot="{ inputValue, inputEvents }">
                        <span class="mr-2">{{ $t('to') | capitalize }}:</span>
                        <input
                          style="border-style: double !important;"
                          class="bg-white border px-2 py-1 rounded time-input mr-2"
                          :value="inputValue"
                          v-on="inputEvents"
                        />
                      </template>
                    </vc-date-picker>
                    <v-select
                      :label="$t('channel')|capitalize"
                      hide-details
                      v-model="selected_channel"
                      :items="channel_list"
                    >
                    </v-select>
                  </div>

                    <v-flex xs12 sm12 md12>
                        <div class="text-xs-right">
                            <v-btn color="error" class="add-custom-info" @click="openConfirmBulkMAD()">
                                {{$t('bulkMadAllButton')|capitalize}}
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-dialog v-model="showDialogConfirmBulkMAD" width="500" persistent>
                <v-card>
                    <div class="fti-dialog-header">
                        <div class="ml-3">{{$t('bulkMadAllRequestSupport')|capitalize}}</div>
                        <v-spacer></v-spacer>
                        <v-btn flat icon @click="showDialogConfirmBulkMAD = false">
                            <v-icon color="#fff">mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <div class="text-xs-center my-3">
                        <span v-if="ls_type==='all'">{{$t('bulkMADAllConfirm')|capitalize}}</span>
                        <span v-else-if="ls_type==='not_assigned'">{{$t('bulkMADNotAssignedConfirm')|capitalize}}</span>
                        <span v-else-if="ls_type==='assigned'">{{$t('bulkMADAssignedConfirm')|capitalize}}</span>
                    </div>
                    <div class="text-xs-center">
                        <v-btn class="add-custom-info" color="error" @click="confirmBulkMAD">
                            {{$t('bulkMadAllButton')|capitalize}}
                        </v-btn>
                        <v-btn class="add-custom-info" color="grey" @click="showDialogConfirmBulkMAD = false">
                            {{$t('cancel')|capitalize}}
                        </v-btn>
                    </div>
                    <div class="chat_view_loading" v-if="loadingDialog">
                        <div class="loading_overlay"></div>
                        <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
                    </div>
                </v-card>
            </v-dialog>
            <div class="chat_view_loading" v-if="loadingDialog">
                <div class="loading_overlay"></div>
                <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
            </div>
        </v-card>
    </v-container>
</template>
<script>
import moment from "moment";
import BotService from "@/services/bot.service";
import {mapActions, mapState} from "vuex";
import utils from "@/services/utils";

export default {
        name: "BulkMAD",
        props: {
            botCode: String
        },
        computed: {
          ...mapState('config', ['botConfig'])
        },
        data() {
            return {
                loadingDialog: false,
                showDialogConfirmBulkMAD: false,
                ls_types: [
                    {text: this.$t('bulkMADAll'), value: 'all'},
                    {text: this.$t('bulkMADNotAssigned'), value: 'not_assigned'},
                    {text: this.$t('bulkMADAssigned'), value: 'assigned'},
                ],
                masks: {
                  input: 'DD-MM-YYYY HH:mm',
                },
                max_date: moment().toDate(),
                ls_type: "all",
                from_time: null,
                to_time: null,
                channel_list: [],
                selected_channel: '',
            }
        },
        watch: {
          from_time() {
            if (this.to_time < this.from_time) {
              this.to_time = this.from_time;
              return
            }
            let max_time = moment(this.from_time).add(1, "months").toDate();
            if (this.to_time > max_time)
              this.to_time = max_time
          },
          to_time() {
            if (this.to_time < this.from_time) {
              this.from_time = this.to_time;
              return
            }
            let min_time = moment(this.to_time).subtract(1, "months").toDate();
            if (this.from_time < min_time)
              this.from_time = min_time
          },
        },
        mounted() {
          if (this.botCode) {
            this.from_time = moment().subtract(7, "days").toDate();
            this.to_time = moment().toDate();
            BotService.getListChannels(this.botCode).then((list_channels) => {
              let channels = utils.smoothListChannels(list_channels.data.channels);
              for(let channel of channels){
                this.channel_list.push({text: this.channelFormat(channel), value: channel === "all" ? "" : channel});
              }
            });
          }
        },
        methods: {
            ...mapActions('dialog', ['closeDialogBlockCustomer']),
            openConfirmBulkMAD() {
                this.showDialogConfirmBulkMAD = true;
            },
            confirmBulkMAD() {
                let from_time = moment(this.from_time), to_time = moment(this.to_time),
                  diff_min = to_time.diff(from_time, "minutes");
                if (diff_min < 0 || diff_min > 44640) {
                  this.$AppService.toastError(this.$t("bulkMadAllTimeRangeTooLarge"));
                  return
                }
                this.loadingDialog = true;
                BotService.bulkMAD(this.botCode, this.ls_type, this.from_time, this.to_time, this.selected_channel).then(() => {
                    this.$AppService.toastSuccess(this.$t("bulkMADSuccess"));
                }).catch((e) => {
                    console.error(e)
                    this.$AppService.toastError(this.$t("bulkMADFailed"));
                }).finally(() => {
                    this.loadingDialog = false;
                    this.showDialogConfirmBulkMAD = false;
                })
            },
            channelFormat(channel){
              return this.stringFormat( this.$t(channel))
            },
            stringFormat(string){
              if(string){
                string = string.split("_");
                for (var i = 0, x = string.length; i < x; i++) {
                  string[i] = string[i][0].toUpperCase() + string[i].substr(1);
                }
                string = string.join(" ");
              }

              return string
            },
        }
    }
</script>

<style scoped>
    ::v-deep .v-card {
        border-radius: 4px !important;
    }

    .add-custom-info {
        color: #FFFFFF;
        text-transform: none;
        font-weight: bold;
        border-radius: 5px !important;
        margin-left: 0px !important;
    }

    .headline {
        color: #FFFFFF;
        font-size: 18px !important;
        line-height: 30px;
    }

    .fti-dialog-header {
        display: flex;
        align-items: center;
        background: #0052CC;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        height: 40px;
    }
</style>
<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 5%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }
</style>
